import { Component, Input } from '@angular/core';
import { Responsive } from 'libs/ui/src/lib/responsive';

@Component({
  template: '',
})
export class BaseSectionComponent extends Responsive {
  @Input() goToFree: () => void;
  @Input() goToPrimary: (sectionType: string) => void;
  @Input() sectionType: string;
  @Input() showVideo: (sectionType: string) => void;
  @Input() options?: any;
}
